import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";

import Layout from "../components/Layout";
import Slider from "../components/Slider";
import SaleBanner from "../components/SaleBanner";
import Articles from "../components/Articles";
import InfoFooter from "../components/InfoFooter";
import home from "../content/home";
import { SHOP } from "../config";

import optometryIcon from "../img/optometry.png";
import glassesIcon from "../img/glasses.png";
import accessoriesIcon from "../img/accessories.png";

const Home = () => (
  <Layout>
    <Helmet
      title="Domovská stránka | Optika Volyně"
      meta={[
        {
          name: "description",
          content:
            "Web Optiky Volyně, která prodává brýle, optické produkty a poskytuje služby péče o zrak",
        },
        {
          name: "keywords",
          content: "Optika, Optometrie, Volyně, Brýle, Zrak, Oči",
        },
      ]}
    />
    <main className="homepage-main">
      <SaleBanner>{home.disclaimer}</SaleBanner>

      <Slider images={home.uvodniFoto}>
        <p className="slider-sale">
          {home.uvodniText.firstRow} {home.uvodniText.secondRow}
        </p>
        <div className="slider-text">
          <p className="slider-text-sale">
            {home.uvodniText.thirdRow}{" "}
            <span className="slider-text-brand">
              {home.uvodniText.coloredText}
            </span>
          </p>
        </div>
        <div className="hero-cta">
          <a
            className="btn-primary"
            href={SHOP.reservio}
            target="_blank"
            rel="noreferrer"
          >
            <i className="fa fa-calendar-check-o" />
            Objednat se online
          </a>
          <Link className="btn-ghost" to="/sluzby">
            Prohlédnout sortiment
          </Link>
        </div>
      </Slider>

      <section className="home-intro">
        <span className="eyebrow">Novinky &amp; akce</span>
        <h2 className="section-title">Co je u nás nového</h2>
      </section>

      <Articles preview limit={4} />

      <section className="home-intro">
        <span className="eyebrow">Naše péče o zrak</span>
        <h2 className="section-title">Vyberte si z naší nabídky</h2>
      </section>

      <div className="icons">
        <Link to="/sluzby/optometrie" className="icon-container">
          <h2>Optometrie</h2>
          <img alt="optometry-icon" src={optometryIcon} />
        </Link>
        <Link to="/sluzby/bryle" className="icon-container">
          <h2>Brýle</h2>
          <img alt="glasses-icon" src={glassesIcon} />
        </Link>
        <Link to="/sluzby/doplnky" className="icon-container">
          <h2>Doplňky</h2>
          <img alt="accessories-icon" src={accessoriesIcon} />
        </Link>
      </div>

      <div className="bottom-section">
        <section>
          <h2>{home.section.heading}</h2>
          <p>{home.section.text}</p>
          <a
            className="mapy-image-cover"
            target="_blank"
            rel="noreferrer"
            href={`https://mapy.com/cs/?source=firm&id=${SHOP.mapyBadgeId}&firmBadge=1`}
          >
            <img
              src={`https://mapy.com/firm-badge.svg?id=${SHOP.mapyBadgeId}&source=firm`}
              alt="Hodnocení na Mapy.cz"
            />
          </a>
        </section>
        <img
          className="section-photo"
          src={home.section.image.src}
          alt={home.section.image.alt}
          loading="lazy"
        />
      </div>

      <InfoFooter />
    </main>
  </Layout>
);

export default Home;
